// @ts-nocheck
import { createReducer } from '@reduxjs/toolkit';
import { persistReducer, purgeStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTableStateReducers } from '@/store/tableState.reducer';
import t from '@/store/types';

export const defaultTableQuery = {
  pageSize: 20,
  pageIndex: 0,
  filterRoles: [],
  sortBy: [],
  viewSlug: null,
};

const initialState = {
  tableState: defaultTableQuery,
};

const STORAGE_KEY = 'ijecapital:payables';

const CONFIG = {
  key: STORAGE_KEY,
  whitelist: [],
  storage,
};

const payablesReducer = createReducer(initialState, (builder) => {
  builder.addCase(t.PAYABLES_TABLE_STATE_SET, (state, action) => {
    state.tableState = {
      ...state.tableState,
      ...action.payload,
    };
    state.tableStateChanged = true;
  });

  builder.addCase(t.PAYABLES_TABLE_STATE_RESET, (state) => {
    state.tableState = defaultTableQuery;
    state.tableStateChanged = false;
  });
});

export default persistReducer(CONFIG, payablesReducer);
